import { useState } from "react";
import { faqData } from "@/mocks/faq";

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section id="faq" className="w-full py-16 md:py-24 bg-background-50">
      <div className="max-w-[800px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <p className="text-xs font-label font-semibold uppercase tracking-wider text-foreground-500 mb-3">
            Got Questions?
          </p>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950">
            Frequently Asked Questions
          </h2>
        </div>

        <div className="space-y-3">
          {faqData.map((faq, index) => (
            <div
              key={index}
              className="bg-background-100 rounded-xl border border-background-200/50 overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full flex items-center justify-between px-5 md:px-6 py-4 md:py-5 text-left cursor-pointer hover:bg-background-200/30 transition-colors"
              >
                <span className="font-heading text-base md:text-lg font-semibold text-foreground-950 pr-4">
                  {faq.question}
                </span>
                <span className="flex-shrink-0 w-8 h-8 rounded-full bg-background-200/70 flex items-center justify-center">
                  <i
                    className={`ri-${openIndex === index ? "subtract" : "add"}-line text-foreground-700 text-base transition-transform duration-200`}
                  ></i>
                </span>
              </button>
              {openIndex === index && (
                <div className="px-5 md:px-6 pb-5 md:pb-6">
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}